import Joi from '@hapi/joi'

export const factoryItemStatusReportSchema = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Please select valid Group`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Company").messages({
        "any.invalid": `Please select valid Company`,
        "any.required": `Company required`
    }),
    collectionPointID: Joi.number().label("Collectionpoint").messages({
        "any.invalid": `Please select valid Collectionpoint`,
        "any.required": `Collectionpoint required`
    }),
    toDate: Joi.string().invalid("").label("Date").required().messages({
        "any.invalid": `Please select Date`,
        "any.required": `Date required`
    }),
    fromDate: Joi.string().invalid("").label("Date").required().messages({
        "any.invalid": `Please select Date`,
        "any.required": `Date required`
    }),
    itemCategoryID: Joi.number().label("Item Catagory").messages({
         "any.invalid": `Please select valid Item Catagory`,
         "any.required": `Item Catagory required`
     }),
     statusID: Joi.number().label("Status").messages({
        "any.invalid": `Please select valid Status`,
        "any.required": `Status required`
    }),
    factoryItemID: Joi.number().label("Factory Items").messages({
        "any.invalid": `Please select valid Factory Item`,
        "any.required": `Factory Item required`
    }),
}